// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file conversions_developers/v1/service.proto (package conversions_developers.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Secret, SecretJson, UserApiToken, UserApiTokenJson } from "./token_pb";
import { file_conversions_developers_v1_token } from "./token_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file conversions_developers/v1/service.proto.
 */
export const file_conversions_developers_v1_service: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_pagination, file_conversions_developers_v1_token, file_google_api_annotations, file_google_protobuf_timestamp],
	);

/**
 * request to create an user-level API token
 *
 * @generated from message conversions_developers.v1.CreateUserApiTokenRequest
 */
export type CreateUserApiTokenRequest = Message<"conversions_developers.v1.CreateUserApiTokenRequest"> & {
	/**
	 * name of the API token, must be unique for the scope
	 * at which it is generated
	 *
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * optional description for the token
	 *
	 * @generated from field: string description = 2;
	 */
	description: string;
};

/**
 * request to create an user-level API token
 *
 * @generated from message conversions_developers.v1.CreateUserApiTokenRequest
 */
export type CreateUserApiTokenRequestJson = {
	/**
	 * name of the API token, must be unique for the scope
	 * at which it is generated
	 *
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * optional description for the token
	 *
	 * @generated from field: string description = 2;
	 */
	description?: string;
};

/**
 * Describes the message conversions_developers.v1.CreateUserApiTokenRequest.
 * Use `create(CreateUserApiTokenRequestSchema)` to create a new message.
 */
export const CreateUserApiTokenRequestSchema: GenMessage<CreateUserApiTokenRequest, { jsonType: CreateUserApiTokenRequestJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 0);

/**
 * user api token creation response
 *
 * @generated from message conversions_developers.v1.CreateUserApiTokenResponse
 */
export type CreateUserApiTokenResponse = Message<"conversions_developers.v1.CreateUserApiTokenResponse"> & {
	/**
	 * @generated from field: conversions_developers.v1.UserApiToken user_api_token = 1;
	 */
	userApiToken?: UserApiToken;
};

/**
 * user api token creation response
 *
 * @generated from message conversions_developers.v1.CreateUserApiTokenResponse
 */
export type CreateUserApiTokenResponseJson = {
	/**
	 * @generated from field: conversions_developers.v1.UserApiToken user_api_token = 1;
	 */
	userApiToken?: UserApiTokenJson;
};

/**
 * Describes the message conversions_developers.v1.CreateUserApiTokenResponse.
 * Use `create(CreateUserApiTokenResponseSchema)` to create a new message.
 */
export const CreateUserApiTokenResponseSchema: GenMessage<CreateUserApiTokenResponse, { jsonType: CreateUserApiTokenResponseJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 1);

/**
 * filter for listing tokens
 *
 * @generated from message conversions_developers.v1.ApiTokenFilter
 */
export type ApiTokenFilter = Message<"conversions_developers.v1.ApiTokenFilter"> & {
	/**
	 * returns tokens containing the name
	 *
	 * @generated from field: optional string token_name = 1;
	 */
	tokenName?: string;
};

/**
 * filter for listing tokens
 *
 * @generated from message conversions_developers.v1.ApiTokenFilter
 */
export type ApiTokenFilterJson = {
	/**
	 * returns tokens containing the name
	 *
	 * @generated from field: optional string token_name = 1;
	 */
	tokenName?: string;
};

/**
 * Describes the message conversions_developers.v1.ApiTokenFilter.
 * Use `create(ApiTokenFilterSchema)` to create a new message.
 */
export const ApiTokenFilterSchema: GenMessage<ApiTokenFilter, { jsonType: ApiTokenFilterJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 2);

/**
 * request for listing all API tokens for the user
 * use the filters to get more specific views
 *
 * @generated from message conversions_developers.v1.ListUserApiTokensRequest
 */
export type ListUserApiTokensRequest = Message<"conversions_developers.v1.ListUserApiTokensRequest"> & {
	/**
	 * @generated from field: conversions_developers.v1.ApiTokenFilter filter = 1;
	 */
	filter?: ApiTokenFilter;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments;
};

/**
 * request for listing all API tokens for the user
 * use the filters to get more specific views
 *
 * @generated from message conversions_developers.v1.ListUserApiTokensRequest
 */
export type ListUserApiTokensRequestJson = {
	/**
	 * @generated from field: conversions_developers.v1.ApiTokenFilter filter = 1;
	 */
	filter?: ApiTokenFilterJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message conversions_developers.v1.ListUserApiTokensRequest.
 * Use `create(ListUserApiTokensRequestSchema)` to create a new message.
 */
export const ListUserApiTokensRequestSchema: GenMessage<ListUserApiTokensRequest, { jsonType: ListUserApiTokensRequestJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 3);

/**
 * response containing all user api tokens at the requested scope
 *
 * @generated from message conversions_developers.v1.ListUserApiTokensResponse
 */
export type ListUserApiTokensResponse = Message<"conversions_developers.v1.ListUserApiTokensResponse"> & {
	/**
	 * @generated from field: repeated conversions_developers.v1.UserApiToken user_api_tokens = 1;
	 */
	userApiTokens: UserApiToken[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * response containing all user api tokens at the requested scope
 *
 * @generated from message conversions_developers.v1.ListUserApiTokensResponse
 */
export type ListUserApiTokensResponseJson = {
	/**
	 * @generated from field: repeated conversions_developers.v1.UserApiToken user_api_tokens = 1;
	 */
	userApiTokens?: UserApiTokenJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message conversions_developers.v1.ListUserApiTokensResponse.
 * Use `create(ListUserApiTokensResponseSchema)` to create a new message.
 */
export const ListUserApiTokensResponseSchema: GenMessage<ListUserApiTokensResponse, { jsonType: ListUserApiTokensResponseJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 4);

/**
 * request for deleting a user-level api token
 *
 * @generated from message conversions_developers.v1.DeleteUserApiTokenRequest
 */
export type DeleteUserApiTokenRequest = Message<"conversions_developers.v1.DeleteUserApiTokenRequest"> & {
	/**
	 * @generated from field: string token_id = 1;
	 */
	tokenId: string;
};

/**
 * request for deleting a user-level api token
 *
 * @generated from message conversions_developers.v1.DeleteUserApiTokenRequest
 */
export type DeleteUserApiTokenRequestJson = {
	/**
	 * @generated from field: string token_id = 1;
	 */
	tokenId?: string;
};

/**
 * Describes the message conversions_developers.v1.DeleteUserApiTokenRequest.
 * Use `create(DeleteUserApiTokenRequestSchema)` to create a new message.
 */
export const DeleteUserApiTokenRequestSchema: GenMessage<DeleteUserApiTokenRequest, { jsonType: DeleteUserApiTokenRequestJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 5);

/**
 * empty response for deletion requests
 *
 * @generated from message conversions_developers.v1.DeleteUserApiTokenResponse
 */
export type DeleteUserApiTokenResponse = Message<"conversions_developers.v1.DeleteUserApiTokenResponse"> & {};

/**
 * empty response for deletion requests
 *
 * @generated from message conversions_developers.v1.DeleteUserApiTokenResponse
 */
export type DeleteUserApiTokenResponseJson = {};

/**
 * Describes the message conversions_developers.v1.DeleteUserApiTokenResponse.
 * Use `create(DeleteUserApiTokenResponseSchema)` to create a new message.
 */
export const DeleteUserApiTokenResponseSchema: GenMessage<DeleteUserApiTokenResponse, { jsonType: DeleteUserApiTokenResponseJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 6);

/**
 * request to view the secrets tied to the user-level API token
 *
 * @generated from message conversions_developers.v1.ViewUserApiTokenSecretRequest
 */
export type ViewUserApiTokenSecretRequest = Message<"conversions_developers.v1.ViewUserApiTokenSecretRequest"> & {
	/**
	 * @generated from field: string token_id = 1;
	 */
	tokenId: string;
};

/**
 * request to view the secrets tied to the user-level API token
 *
 * @generated from message conversions_developers.v1.ViewUserApiTokenSecretRequest
 */
export type ViewUserApiTokenSecretRequestJson = {
	/**
	 * @generated from field: string token_id = 1;
	 */
	tokenId?: string;
};

/**
 * Describes the message conversions_developers.v1.ViewUserApiTokenSecretRequest.
 * Use `create(ViewUserApiTokenSecretRequestSchema)` to create a new message.
 */
export const ViewUserApiTokenSecretRequestSchema: GenMessage<ViewUserApiTokenSecretRequest, { jsonType: ViewUserApiTokenSecretRequestJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 7);

/**
 * response including the secret
 *
 * @generated from message conversions_developers.v1.ViewUserApiTokenSecretResponse
 */
export type ViewUserApiTokenSecretResponse = Message<"conversions_developers.v1.ViewUserApiTokenSecretResponse"> & {
	/**
	 * @generated from field: conversions_developers.v1.Secret secret = 1;
	 */
	secret?: Secret;
};

/**
 * response including the secret
 *
 * @generated from message conversions_developers.v1.ViewUserApiTokenSecretResponse
 */
export type ViewUserApiTokenSecretResponseJson = {
	/**
	 * @generated from field: conversions_developers.v1.Secret secret = 1;
	 */
	secret?: SecretJson;
};

/**
 * Describes the message conversions_developers.v1.ViewUserApiTokenSecretResponse.
 * Use `create(ViewUserApiTokenSecretResponseSchema)` to create a new message.
 */
export const ViewUserApiTokenSecretResponseSchema: GenMessage<ViewUserApiTokenSecretResponse, { jsonType: ViewUserApiTokenSecretResponseJson }> = /*@__PURE__*/ messageDesc(file_conversions_developers_v1_service, 8);

/**
 * @generated from service conversions_developers.v1.ConversionsDevelopersService
 */
export const ConversionsDevelopersService: GenService<{
	/**
	 * @generated from rpc conversions_developers.v1.ConversionsDevelopersService.CreateUserApiToken
	 */
	createUserApiToken: {
		methodKind: "unary";
		input: typeof CreateUserApiTokenRequestSchema;
		output: typeof CreateUserApiTokenResponseSchema;
	};
	/**
	 * @generated from rpc conversions_developers.v1.ConversionsDevelopersService.ListUserApiTokens
	 */
	listUserApiTokens: {
		methodKind: "unary";
		input: typeof ListUserApiTokensRequestSchema;
		output: typeof ListUserApiTokensResponseSchema;
	};
	/**
	 * @generated from rpc conversions_developers.v1.ConversionsDevelopersService.DeleteUserApiToken
	 */
	deleteUserApiToken: {
		methodKind: "unary";
		input: typeof DeleteUserApiTokenRequestSchema;
		output: typeof DeleteUserApiTokenResponseSchema;
	};
	/**
	 * @generated from rpc conversions_developers.v1.ConversionsDevelopersService.ViewUserApiTokenSecret
	 */
	viewUserApiTokenSecret: {
		methodKind: "unary";
		input: typeof ViewUserApiTokenSecretRequestSchema;
		output: typeof ViewUserApiTokenSecretResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_conversions_developers_v1_service, 0);
